import Card from 'react-bootstrap/Card';
import logofoot from '../assets/Images/whitehawk/correct.png';
import React from 'react';

import { useState } from "react";


function WhiteHawkCard(props) {
  const [description, setDescription] = useState(false);

  function appear() {
    setDescription(true);
  }
  function disappear() {
    setDescription(false);
  }


  return (

    <Card onMouseOver={appear} onMouseOut={disappear} className={'bg-transparent whitehawk-card  WhiteHawkcard'} style={{
      height: '450px',
      boxShadow: '0 3px 15px  rgba(0, 0, 0, 0.5) ',borderRadius:'25px'
      // rgb(51 51 51 / 64%) 0px -90px 30px -20px inset
    }} >
      <Card.Header className={'bg-transparent  border-0'} style={{transition: 'all  0.3s ease',marginBottom: description ? '10px' : null}}>

      </Card.Header>
      <Card.Body style={{ transition: 'all  0.3s ease' }} >
        <h4 className={'bolder text-black'}>{props.Title}</h4 >
        {/*<Card.Subtitle className="mb-2 text-muted">Card Subtitle</Card.Subtitle>*/}
        <Card.Text className={'mt-4 fs-4'}>
          {props.text}

        </Card.Text>
      </Card.Body>
          <img src={logofoot} width={'15%'} style={{ marginLeft: '85%',marginBottom:'20px' }} />

    </Card>
  );
}

export default WhiteHawkCard;